module.exports = __webpack_public_path__ + "0efca54711aed311a8a8dd12dc112abf.jpg";